var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { flatten, partition } from 'lodash';
import { initializeFilters, descendingComparator, filterFunction, isAllFiltersDefaulted } from './utils';
export function useStringFilters(rows, columns, filterConfigs) {
    var _a = useState(initializeFilters(columns, filterConfigs)), filters = _a[0], setFilters = _a[1];
    return {
        filters: filters,
        filteredRows: rows.filter(function (row) { return filterFunction(row, filters); }),
        isAllFiltersDefaulted: isAllFiltersDefaulted(filters, filterConfigs),
        resetFilters: function () { return setFilters(initializeFilters(columns, filterConfigs)); },
        setFilter: function (column, value) {
            var _a;
            setFilters(__assign(__assign({}, filters), (_a = {}, _a[column] = value, _a)));
        },
    };
}
export function useOrderBy(rows, columns, rowCheckIsDisabled) {
    var _a = useState('asc'), order = _a[0], setOrder = _a[1];
    var _b = useState(columns[0]), orderBy = _b[0], setOrderBy = _b[1];
    var sortFn = function (a, b) { return (order === 'desc' ? 1 : -1) * descendingComparator(a, b, orderBy); };
    return {
        order: order,
        orderBy: orderBy,
        orderedRows: flatten(
        // rows with disabled check are displayed sorted at the end
        partition(rows, function (row) { return !rowCheckIsDisabled(row); })
            .map(function (part) { return part.sort(sortFn); })),
        sortBy: function (property) {
            var isAsc = orderBy === property && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(property);
        },
        resetOrder: function () {
            setOrder('asc');
            setOrderBy(columns[0]);
        }
    };
}
export function useCheckedRow(rows, rowCheckIsDisabled, onCheck) {
    var _a = useState([]), checked = _a[0], setCheckedCore = _a[1];
    var setChecked = function (ids) {
        setCheckedCore(ids);
        if (onCheck) {
            onCheck(ids);
        }
    };
    return {
        checked: checked,
        resetChecked: function () { return setChecked([]); },
        checkAll: function (isCheckAllChecked) {
            if (isCheckAllChecked) {
                var newChecked = rows
                    // disabled rows cannot be checked
                    .filter(function (row) { return !rowCheckIsDisabled(row); })
                    .map(function (n) { return n.id; });
                setChecked(newChecked);
                return;
            }
            setChecked([]);
        },
        checkRow: function (rowId) {
            setChecked(checked.includes(rowId)
                ? checked.filter(function (id) { return id !== rowId; })
                : __spreadArray(__spreadArray([], checked, true), [rowId], false));
        },
        isRowChecked: function (rowId) { return checked.indexOf(rowId) !== -1; }
    };
}
//# sourceMappingURL=hooks.js.map